/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class BankAccountDtoModel extends JSONable {
  uuid: string | undefined = undefined;
  iban: string | undefined = undefined;
  currencyCode: string | undefined = undefined;
  swiftCode: string | undefined = undefined;
  bankName: string | undefined = undefined;
  status: string | undefined = undefined;
  type: string | undefined = undefined;
  legalEntityUuid: string | undefined = undefined;

  constructor() {
    super();
    this.uuid = undefined;
    this.iban = undefined;
    this.currencyCode = undefined;
    this.swiftCode = undefined;
    this.bankName = undefined;
    this.status = undefined;
    this.type = undefined;
    this.legalEntityUuid = undefined;
  }
}
